<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="titleView" v-if="tabs == 1">
      <div class="mr">
        <el-input
          v-model="params.keyword"
          clearable
          @change="searchPurchase"
          prefix-icon="el-icon-search"
          placeholder="商品名称"
          style="width: 160px"
          size="small"
        />
        <el-button style="margin-left: 10px" type="warning" size="small"
          >搜索</el-button
        >
      </div>
      <div class="mr">
        <span style="margin-right: 10px">申请日期</span>
        <el-date-picker
          value-format="timestamp"
          @change="searchPurchase"
          v-model="dataTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="titleDate"
          style="width: 224px"
          size="small"
        />
      </div>

      <div class="mr">
        <span style="margin-right: 10px">状态</span>
        <el-select
          v-model="params.state"
          placeholder="请选择"
          @change="searchPurchase"
          size="small"
          style="width: 120px"
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="待提交" :value="-2"></el-option>
          <el-option label="未审批" :value="1"></el-option>
          <el-option label="已通过" :value="2"></el-option>
          <el-option label="已驳回" :value="3"></el-option>
          <el-option label="采购中" :value="4"></el-option>
          <el-option label="采购完成" :value="5"></el-option>
        </el-select>
      </div>

      <div class="mr">
        <el-button @click="reset" size="small">重置</el-button>
      </div>
      <div style="text-align: right; flex: 1">
        <!-- <el-button type="warning" @click='isAddNewGoods = true' size="small">添加新品</el-button> -->
        <el-button v-if="$buttonAuthority('cangku-caigouMendian-apply')" icon="el-icon-document" @click="addShopPurchase" size="small"
          >申请采购</el-button
        >
      </div>
    </div>

    <div class="titleView" v-if="tabs == 2">
      <div class="mr">
        <el-input
          clearable
          v-model="acceptanceParams.keyword"
          prefix-icon="el-icon-search"
          placeholder="条码/商品名称/分拨单号"
          style="width: 220px"
          @change="searchacceptancedata"
          size="small"
        />
        <el-button style="margin-left: 10px" type="warning" size="small"
          >搜索</el-button
        >
      </div>
      <div class="mr">
        <span style="margin-right: 5px">验货日期</span>
        <el-date-picker
          @change="searchacceptancedata"
          v-model="acceptancedataTime"
          value-format="timestamp"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="titleDate"
          style="width: 224px"
          size="small"
        />
      </div>

      <div class="mr">
        <span style="margin-right: 10px">状态</span>
        <el-select
          v-model="acceptanceParams.acceptance_state"
          placeholder="请选择"
          @change="searchacceptancedata"
          style="width: 130px"
          size="small"
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="已验收" :value="1"></el-option>
          <el-option label="部分验收" :value="2"></el-option>
          <el-option label="未验收" :value="3"></el-option>
        </el-select>
      </div>
      <div class="mr">
        <span style="margin-right: 10px">阅读</span>
        <el-select
          v-model="acceptanceParams.is_read"
          placeholder="请选择"
          @change="searchacceptancedata"
          style="width: 100px"
          size="small"
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="已读" :value="1"></el-option>
          <el-option label="未读" :value="2"></el-option>
        </el-select>
      </div>
      <div class="mr">
        <el-button @click="reset" size="small">重置</el-button>
      </div>
    </div>
    <div class="tabLine">
      <div
        v-if="$buttonAuthority('cangku-caigouMendian-caigou')"
        class="tabItem"
        :class="[tabs == 1 ? 'active' : 'noactive']"
        @click="handleTabClick(1)"
      >
        采购列表
      </div>
      <el-badge :value="checkCount != 0 ? checkCount : ''" :max="99">
        <div
        v-if="$buttonAuthority('cangku-caigouMendian-yanshou')"
          class="tabItem"
          :class="[tabs == 2 ? 'active' : 'noactive']"
          @click="handleTabClick(2)"
        >
          验收列表
        </div>
      </el-badge>
    </div>

    <div class="tableView">
      <!-- 采购列表 直接分开 会清晰点 -->
      <template v-if="tabs == 1">
        <el-table :data="purchaseData" style="width: 100%">
          <el-table-column prop="procure_request_no" label="申请批次号">
          </el-table-column>
          <el-table-column prop="procure_goods_count" label="申请日期">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.add_info.create_time) }}
            </template>
          </el-table-column>

          <el-table-column prop="procure_goods_count" label="申请人" width="60">
            <template slot-scope="scope">
              <span v-if="scope.row.add_info">{{
                scope.row.add_info.add_user_info.user_name
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="procure_goods_count" label="采购数量">
							</el-table-column> -->

          <el-table-column
            prop="procure_goods_count"
            label="采购数量"
            width="80"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.procure_goods_count }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="remarks" label="申请备注" width="140px">
            <template slot-scope="scope">
              <span class="remark">{{ scope.row.remarks }} </span>
              <el-popover
                v-if="scope.row.remarks"
                placement="top-start"
                width="200"
                trigger="hover"
                :content="scope.row.remarks"
              >
                <el-button
                  slot="reference"
                  type="text"
                  icon="el-icon-view"
                ></el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.state == -2" style="color: #ffae11"
                >待提交</span
              >
              <!-- <span v-else-if="(scope.row.state==4||scope.row.state==2||scope.row.state==1&&scope.row.is_shop_confirm)" style="color: #FFAE11">待确认</span> -->
              <span v-else-if="scope.row.state == 1" style="color: #ffae11"
                >未审批</span
              >
              <span v-else-if="scope.row.state == 2" style="color: #2a2a2a"
                >已通过</span
              >
              <span v-else-if="scope.row.state == 3" style="color: #ff182a"
                >已驳回</span
              >
              <span v-else-if="scope.row.state == 4" style="color: #2a2a2a"
                >采购中</span
              >
              <span v-else-if="scope.row.state == 5" style="color: #67c23a"
                >采购完成</span
              >
            </template>
          </el-table-column>
          <el-table-column label="是否确认" width="100">
            <template slot-scope="scope">
              <span style="color: #2a2a2a">{{
                scope.row.is_shop_confirm
                  ? scope.row.shop_confirm == null
                    ? "需确认"
                    : "已确认"
                  : "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="procure_goods_count" label="审批人" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.check_info">
                {{ scope.row.check_info.check_user_info.user_name }}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="procure_goods_count" label="审批时间">
            <template slot-scope="scope">
              <span v-if="scope.row.check_info">
                {{ $public.FTime(scope.row.check_info.check_time) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.is_shop_confirm && scope.row.shop_confirm == null
                "
                @click="surePurchase(scope.row)"
                icon="el-icon-circle-check
			"
                type="text"
                size="small"
                >确认采购
              </el-button>

              <el-button
                v-if="scope.row.state == -2"
                type="text"
                size="small"
                @click="del(scope.row)"
                >删除</el-button
              >
              <el-button
                v-if="scope.row.state == -2"
                @click="editPurchase(scope.row)"
                icon="el-icon-edit"
                type="text"
                size="small"
                >编辑
              </el-button>
              <el-button
                icon="el-icon-view"
                type="text"
                @click="lookDl(scope.row._id)"
                size="small"
                >查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-if="tabs == 2">
        <el-table :data="inspectionData" style="width: 100%">
          <el-table-column prop="distribution_no" label="分拨批次号">
          </el-table-column>
          <el-table-column prop="create_time" label="采购分拨日期">
            <template slot-scope="scope">
              {{ $public.FTime(scope.row.create_time) }}
            </template>
          </el-table-column>

          <el-table-column prop="name" label="分拨人" width="80">
            <template slot-scope="scope">
              {{ scope.row.add_user.user_name }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 1" style="color: #2a2a2a"
                >已验收</span
              >
              <span v-if="scope.row.state == 2" style="color: #ffae11"
                >部分验收</span
              >
              <span v-if="scope.row.state == 3" style="color: #ff182a"
                >未验收</span
              >
            </template>
          </el-table-column>

          <el-table-column prop="name" label="验收人" width="80">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.received_goods &&
                  scope.row.received_goods.length > 0
                "
              >
                {{
                  scope.row.received_goods[scope.row.received_goods.length - 1]
                    .success_user_info.user_name
                }}</span
              >
            </template>
          </el-table-column>

          <el-table-column prop="name" label="验收日期">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.received_goods &&
                  scope.row.received_goods.length > 0
                "
              >
                {{
                  $public.FTime(
                    scope.row.received_goods[
                      scope.row.received_goods.length - 1
                    ].received_time
                  )
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="name" label="阅读状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.is_read == 0"> 未读 </span>
              <span v-if="scope.row.is_read == 1"> 已读 </span>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="验收备注">
            <template slot-scope="scope">
              <span class="remark">{{ scope.row.remarks }} </span>
              <el-popover
                v-if="scope.row.remarks"
                placement="top-start"
                width="200"
                trigger="hover"
                :content="scope.row.remarks"
              >
                <el-button
                  slot="reference"
                  type="text"
                  icon="el-icon-view"
                ></el-button>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.state != 1"
                icon="el-icon-edit"
                type="text"
                @click="inspectionEdit(scope.row.distribution_no)"
                size="small"
                >验货</el-button
              >
              <el-button
                icon="el-icon-view"
                type="text"
                @click="inspectionLook(scope.row.distribution_no)"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <page
        :page="params.page_index"
        :total="total"
        @change="changePage"
        style="padding: 10px 0; background: #fff"
      >
      </page>
    </div>

    <el-dialog
      title="采购申请单查看"
      :visible.sync="dialogDl"
      :close-on-click-modal="false"
      width="90%"
    >
      <div class="titlecon" v-if="procureRequestDetail">
        <div class="titleleft">
          <span>申请批次号: {{ procureRequestDetail.procure_request_no }}</span>
          <span v-if="procureRequestDetail.add_info"
            >申请日期：
            {{ $public.FTime(procureRequestDetail.add_info.create_time) }}</span
          >
          <span
            >期望到货日期:
            {{
              $public.FTime(procureRequestDetail.expect_time, "YYYY-MM-DD")
            }}</span
          >
          <span>
            状态:
            <span v-if="procureRequestDetail.state == -2" style="color: #ffae11"
              >待提交</span
            >
            <!-- <span v-else-if="(procureRequestDetail.state==4||procureRequestDetail.state==2||procureRequestDetail.state==1&&procureRequestDetail.is_shop_confirm)"
						style="color: #FFAE11">待确认</span> -->
            <span
              v-else-if="procureRequestDetail.state == 1"
              style="color: #ffae11"
              >未审批</span
            >
            <span
              v-else-if="procureRequestDetail.state == 2"
              style="color: #2a2a2a"
              >已通过</span
            >
            <span
              v-else-if="procureRequestDetail.state == 3"
              style="color: #ff182a"
              >已驳回</span
            >
            <span
              v-else-if="procureRequestDetail.state == 4"
              style="color: #2a2a2a"
              >采购中</span
            >
            <span
              v-else-if="procureRequestDetail.state == 5"
              style="color: #67c23a"
              >采购完成</span
            >
            <el-popover
              style="margin-left: 5px"
              v-if="procureRequestDetail.state == 3"
              placement="bottom"
              width="200"
              trigger="hover"
              :content="procureRequestDetail.check_info.check_remark"
            >
              <el-button
                slot="reference"
                type="text"
                icon="el-icon-view"
              ></el-button>
            </el-popover>
          </span>
          <div>
            <span v-if="procureRequestDetail.add_info"
              >申请人:{{
                procureRequestDetail.add_info.add_user_info.user_name
              }}</span
            >
            <span v-if="procureRequestDetail.check_info"
              >审批人:{{
                procureRequestDetail.check_info.check_user_info.user_name
              }}</span
            >
            <span v-if="procureRequestDetail.check_info"
              >审批日期:{{
                $public.FTime(procureRequestDetail.check_info.check_time)
              }}</span
            >

            <span>产品数量: {{ procureRequestDetail.goods_count }}</span>
            <span
              >采购数量: {{ procureRequestDetail.procure_goods_count }}</span
            >
            <span>备注: {{ procureRequestDetail.remarks }}</span>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in sumData" :key="index">
        <div class="comH2" @click="handleShopClick(item.goods_type)">
          <div>
            {{
              item.goods_type == 1
                ? "医疗类"
                : item.goods_type == 0
                ? "商品类"
                : "耗材类"
            }}
          </div>
          <i
            v-if="showType['showType' + item.goods_type]"
            class="el-icon-caret-bottom"
          ></i>
          <i v-else class="el-icon-caret-top"></i>
        </div>

        <el-table
          v-show="showType['showType' + item.goods_type]"
          show-summary
          :data="item.goods"
          style="width: 100%"
          size="small"
        >
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.title }}</span>
              <el-tag
                type="success"
                style="margin-left: 10px"
                size="mini"
                v-if="scope.row.procure_goods_state == 2"
              >
                增
              </el-tag>
              <el-tag
                type="warning"
                style="margin-left: 10px"
                size="mini"
                v-if="scope.row.procure_goods_state == 4"
              >
                换
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="品牌" width="120px">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.brand }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.sku_value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="120px">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="采购数量" prop="count" width="180px">
            <template slot-scope="scope">
              {{ scope.row.count }}
            </template>
          </el-table-column>
          <el-table-column label="采购状态" prop="count" width="180px">
            <template slot-scope="scope">
              <span v-if="scope.row.goods_state == 1">申请中</span>
              <span v-if="scope.row.goods_state == 2">部分验货</span>
              <span v-if="scope.row.goods_state == 3">未分拨</span>
              <span v-if="scope.row.goods_state == 4">部分分拨</span>
              <span v-if="scope.row.goods_state == 5">未打码</span>
              <span v-if="scope.row.goods_state == 6">部分打码</span>
              <span v-if="scope.row.goods_state == 7">全部打码</span>
              <span v-if="scope.row.goods_state == 8">分拨出库</span>
              <span v-if="scope.row.goods_state == 9">门店部分收货</span>
              <span v-if="scope.row.goods_state == 10">门店收货</span>
              <span v-if="scope.row.goods_state == -2">无货</span>
              <span v-if="scope.row.goods_state == -3">异常</span>
            </template>
          </el-table-column>
          <el-table-column label="销售单价" width="120px" prop="pprice">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.pprice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="180px">
            <template slot-scope="scope">
              <div class="remark">
                {{ scope.row.procure_goods_remark }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="comH2" @click="handleShopClick(3)">
        <div>修改记录</div>
        <i v-if="showType['showType' + 3]" class="el-icon-caret-bottom"></i>
        <i v-else class="el-icon-caret-top"></i>
      </div>
      <div class="updatetitle">
        <span>原商品</span>
        <span>修改商品</span>
      </div>
      <el-table
        v-show="showType['showType' + 3]"
        show-summary
        :data="procureRequestDetail.update_list"
        style="width: 100%"
        size="small"
      >
        <el-table-column label="商品名称">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procure_goods.goods.title
            }}</span>
            <span v-else>{{
              scope.row.procure_goods_replace
                ? scope.row.procure_goods_replace.goods.title
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procure_goods.goods.brand
            }}</span>
            <span v-else>{{
              scope.row.procure_goods_replace
                ? scope.row.procure_goods_replace.goods.brand
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procure_goods.goods.goods_type == 1
                ? "商品类"
                : "医疗类"
            }}</span>
            <span v-else>{{
              scope.row.procure_goods_replace
                ? scope.row.procure_goods_replace.goods.goods_type == 1
                  ? "商品类"
                  : "医疗类"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procure_goods.goods.sku_value
            }}</span>
            <span v-else>{{
              scope.row.procure_goods_replace
                ? scope.row.procure_goods_replace.goods.sku_value
                : ""
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="采购数量" prop="count" width="180px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procure_goods.order_num
            }}</span>
            <span v-else>{{
              scope.row.procure_goods_replace
                ? scope.row.procure_goods_replace.order_num
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售单价" prop="pprice" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procure_goods.goods.pprice
            }}</span>
            <span v-else>{{
              scope.row.procure_goods_replace
                ? scope.row.procure_goods_replace.goods.pprice
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="pprice" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.procure_goods.delete_remark }}</span>
          </template>
        </el-table-column>

        <el-table-column label="" width="100px">
          <template slot-scope="scope">
            <el-tag type="danger" size="mini" v-if="scope.row.state == 0">
              删
            </el-tag>

            <el-tag type="success" size="mini" v-if="scope.row.state == 2">
              增
            </el-tag>
            <el-tag type="warning" size="mini" v-if="scope.row.state == 4">
              换
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="商品名称">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0"
              >{{
                scope.row.procure_goods_replace
                  ? scope.row.procure_goods_replace.goods.title
                  : ""
              }}
            </span>
            <span v-else>{{ scope.row.procure_goods.goods.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌" width="120px">
          <template slot-scope="scope">
            <!-- <span>{{scope.row.procure_goods.goods.brand}}</span> -->
            <span v-if="scope.row.state == 0">
              {{
                scope.row.procure_goods_replace
                  ? scope.row.procure_goods_replace.goods.brand
                  : ""
              }}
            </span>
            <span v-else>{{ scope.row.procure_goods.goods.brand }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="pprice" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">
              {{
                scope.row.procure_goods_replace
                  ? scope.row.procure_goods_replace.goods.goods_type == 1
                    ? "商品类"
                    : "医疗类"
                  : ""
              }}</span
            >
            <span v-else>{{
              scope.row.procure_goods.goods.goods_type == 1
                ? "商品类"
                : "医疗类"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">
              {{
                scope.row.procure_goods_replace
                  ? scope.row.procure_goods_replace.goods.sku_value
                  : ""
              }}
            </span>
            <span v-else>{{ scope.row.procure_goods.goods.sku_value }}</span>
          </template>
        </el-table-column>

        <el-table-column label="采购数量" prop="count" width="180px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">
              {{
                scope.row.procure_goods_replace
                  ? scope.row.procure_goods_replace.order_num
                  : ""
              }}
            </span>
            <span v-else>{{ scope.row.procure_goods.order_num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售单价" prop="pprice" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{
              scope.row.procure_goods_replace
                ? scope.row.procure_goods_replace.goods.pprice
                : ""
            }}</span>
            <span v-else>{{ scope.row.procure_goods.goods.pprice }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="dialogDl = false" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="验货查看"
      :visible.sync="dialogaccept"
      :close-on-click-modal="false"
      width="90%"
    >
      <div class="titlecon" v-if="inspectionDetail">
        <div class="titleleft">
          <span>分拨批次号: {{ inspectionDetail.distribution_no }}</span>
          <span>分拨人: {{ inspectionDetail.add_user.user_name }}</span>
          <span v-if="inspectionDetail.add_info"
            >分拨人 {{ inspectionDetail.add_user.user_name }}</span
          >
          <span
            >分拨时间: {{ $public.FTime(inspectionDetail.create_time) }}</span
          >
          <span>分拨数量: {{ distributionCount }}</span>
          <span
            >状态:
            <span style="color: #2a2a2a" v-if="inspectionDetail.state == 1"
              >已验收</span
            >
            <span style="color: #ffae11" v-if="inspectionDetail.state == 2"
              >部分验收
            </span>
            <span style="color: #ff182a" v-if="inspectionDetail.state == 3"
              >未验收
            </span></span
          >
          <div>
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收人:
              {{
                inspectionDetail.received_goods[
                  inspectionDetail.received_goods.length - 1
                ].success_user_info.user_name
              }}</span
            >
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收时间:
              {{
                $public.FTime(
                  inspectionDetail.received_goods[
                    inspectionDetail.received_goods.length - 1
                  ].received_time
                )
              }}</span
            >
            <span
              v-if="
                inspectionDetail.received_goods &&
                inspectionDetail.received_goods.length > 0
              "
            >
              验收数量:
              {{
                inspectionDetail.received_goods[
                  inspectionDetail.received_goods.length - 1
                ].received_count
              }}</span
            >
            <span>
              配送人:
              {{
                inspectionDetail.logistics == null ||
                inspectionDetail.logistics.staff == null
                  ? "--"
                  : inspectionDetail.logistics.staff.staff_name
              }}</span
            >
            <span>
              送达时间:
              {{
                inspectionDetail.logistics == null ||
                inspectionDetail.logistics.delivery_success == null
                  ? ""
                  : $public.FTime(
                      inspectionDetail.logistics.delivery_success
                        .opearation_time,
                      "YYYY-MM-DD"
                    )
              }}</span
            >
          </div>
          <div></div>
        </div>
      </div>
      <div v-for="(item, index) in sumData" :key="index">
        <div class="comH2" @click="handleShopClick(item.goods_type)">
          <div>
            {{
              item.goods_type == 1
                ? "医疗类"
                : item.goods_type == 0
                ? "商品类"
                : "耗材类"
            }}
          </div>
          <i
            v-if="showType['showType' + item.goods_type]"
            class="el-icon-caret-bottom"
          ></i>
          <i v-else class="el-icon-caret-top"></i>
        </div>
        <el-table
          row-class-name="row-expand-cove"
          :ref="'table' + item.goods_type"
          v-show="showType['showType' + item.goods_type]"
          show-summary
          :data="item.goods"
          style="width: 100%"
          size="small"
        >
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.brand }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.sku_value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60">
            <template slot-scope="scope">
              <span>{{ scope.row.goods.in_unit }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="分拨数量"
            prop="distribution_count"
            width="80"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.distribution_count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期" prop="count" width="100">
            <template slot-scope="scope">
              <span>{{
                scope.row.distribution_datas_list.length > 1
                  ? "多效期"
                  : $public.FTime(
                      scope.row.distribution_datas_list[0].overdue_time,
                      "YYYY-MM-DD"
                    )
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收数量" width="100" prop="acceptance_count">
            <template slot-scope="scope">
              <span class="">{{ scope.row.acceptance_count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.distribution_count == scope.row.acceptance_count
                "
              >
                <span style="color: #13ce66">•</span>
                已验收
              </span>
              <span
                v-if="
                  scope.row.distribution_count > scope.row.acceptance_count &&
                  scope.row.acceptance_count != 0
                "
              >
                <span style="color: #13ce66">•</span>
                部分验收
              </span>
              <span v-if="scope.row.acceptance_count == 0">
                <span style="color: #e6a23c">•</span>
                未验收
              </span>
              <span
                v-if="
                  scope.row.acceptance_info &&
                  scope.row.acceptance_info.abnormal_info &&
                  (scope.row.acceptance_info.abnormal_info.leakage_count ||
                    scope.row.acceptance_info.abnormal_info.overdue_count ||
                    scope.row.acceptance_info.abnormal_info.broken_count ||
                    scope.row.acceptance_info.abnormal_info.switch_count)
                "
              >
                <span style="color: #ff4d51">•</span>
                异常
                {{
                  scope.row.acceptance_info.abnormal_info.leakage_count +
                  scope.row.acceptance_info.abnormal_info.overdue_count +
                  scope.row.acceptance_info.abnormal_info.broken_count +
                  scope.row.acceptance_info.abnormal_info.switch_count
                }}
                <el-popover
                  popper-class="abnormalpopover"
                  placement="bottom"
                  trigger="click"
                >
                  <div class="abnormal">
                    <div>
                      漏发数量
                      {{
                        scope.row.acceptance_info.abnormal_info.leakage_count
                      }}
                    </div>
                    <div>
                      过期数量
                      {{
                        scope.row.acceptance_info.abnormal_info.overdue_count
                      }}
                    </div>
                    <div>
                      破损数量
                      {{ scope.row.acceptance_info.abnormal_info.broken_count }}
                    </div>
                    <div>
                      调换数量
                      {{ scope.row.acceptance_info.abnormal_info.switch_count }}
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-view"
                  ></el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="验收状态" width="100">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.distribution_count == scope.row.acceptance_count
                "
              >
                <span style="color: #13ce66">•</span>
                已验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
              <span
                v-if="
                  scope.row.distribution_count > scope.row.acceptance_count &&
                  scope.row.acceptance_count != 0
                "
              >
                <span style="color: #13ce66">•</span>
                部分验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
              <span v-if="scope.row.acceptance_count == 0">
                <span style="color: #e6a23c">•</span>
                未验收 {{ scope.row.acceptance_count }} /
                {{ scope.row.distribution_count }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toogleExpand(scope.row)"
                size="small"
              >
                查看条码
              </el-button>
            </template>
          </el-table-column>

          <el-table-column type="expand" width="1">
            <template slot-scope="props">
              <div
                class="goodscustom"
                v-for="(item, index) in props.row.distribution_datas_list"
                :key="index"
              >
                <div>
                  有效期
                  {{ $public.FTime(item.overdue_time, "YYYY-MM-DD") }} 条码数量
                  {{ item.code_count }}
                </div>
                <div style="margin-top: 10px">
                  <el-tag
                    style="margin: 5px"
                    v-for="(goodscustom, subindex) in fillterGoodsCustom(
                      item.goods_code_list
                    )"
                    :key="subindex"
                    :type="
                      goodscustom.is_check || goodscustom.goods_state == 4
                        ? 'success'
                        : 'info'
                    "
                  >
                    {{ goodscustom.code }}
                    总量 {{ goodscustom.totaltimes }}</el-tag
                  >
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <dialogNewGoods
      :dialogStatus="isAddNewGoods"
      @closeDialog="closeDialog"
      :isShopPurchase="true"
    >
    </dialogNewGoods>
  </div>
</template>

<script>
import {
  getProcureRequest,
  confirmProcureRequest,
  procureRequestDl,
  getShopAcceptanceList,
  getNoCheckCount,
  getDistributionInfo,
  delProcureRequest,
} from "@/api/shopPurchaseApi.js";
import page from "../../../components/page.vue";
import dialogNewGoods from "../../../components/dialog_newgood.vue";

export default {
  components: {
    page,
    dialogNewGoods,
  },
  data() {
    return {
      fixedHeight: "",
      isAddNewGoods: false,
      tabs: 1,
      dataTime: "",
      acceptancedataTime: "",
      params: {
        page_index: 1,
        page_size: 10,
        keyword: "",
        shop_id: this.$store.getters.curShopInfo.shop_id,
        starttime: "",
        endtime: "",
        user_id: this.$store.state.userInfo.uid,
        state: -1,
      },
      total: 0,
      purchaseData: [],
      dialogDl: false,
      procureRequestDetail: "",
      sumData: [],
      showType: {
        showType0: true,
        showType1: true,
        showType7: true,
        showType3: true,
      },
      acceptanceParams: {
        page_index: 1,
        page_size: 10,
        keyword: "",
        acceptance_state: -1,
        shop_id: this.$store.getters.curShopInfo.shop_id,
        starttime: "",
        endtime: "",
        is_read: -1,
      },
      inspectionData: [],
      checkCount: 0,
      dialogaccept: false,
      inspectionDetail: "",
    };
  },
  computed: {
    //计算分拨总数量
    distributionCount() {
      let distributionCount = 0;
      this.inspectionDetail.linkData.forEach((item) => {
        distributionCount += item.distribution_count;
      });
      return distributionCount;
    },
  },
  methods: {
    //删除待提交的申请单
    del(row) {
      this.$confirm("此操作将删除该申请单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row._id,
          };
          delProcureRequest(params).then((res) => {
            if (res.code == 0) {
              this.getProcureRequest();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    closeDialog(val) {
      console.log(val);
      this.isAddNewGoods = val;
    },
    toogleExpand(row) {
      let $table = this.$refs["table" + row.goods.goods_type][0];
      $table.toggleRowExpansion(row);
    },
    searchPurchase() {
      this.params.page_index = 1;
      this.params.starttime =
        this.dataTime && this.dataTime[0].toString().length > 10
          ? this.dataTime[0].toString().substr(0, 10)
          : "";
      this.params.endtime =
        this.dataTime && this.dataTime[1].toString().length > 10
          ? this.dataTime[1].toString().substr(0, 10)
          : "";
      this.getProcureRequest();
    },
    searchacceptancedata() {
      this.acceptanceParams.page_index = 1;
      this.acceptanceParams.starttime =
        this.acceptancedataTime &&
        this.acceptancedataTime[0].toString().length > 10
          ? this.acceptancedataTime[0].toString().substr(0, 10)
          : "";
      this.acceptanceParams.endtime =
        this.acceptancedataTime &&
        this.acceptancedataTime[1].toString().length > 10
          ? this.acceptancedataTime[1].toString().substr(0, 10)
          : "";
      this.getShopAcceptanceList();
    },
    //改变页数
    changePage(val) {
      if (this.tabs == 1) {
        this.params.page_index = val;
        this.getProcureRequest();
      } else {
        this.acceptanceParams.page_index = val;
        this.getShopAcceptanceList();
      }
    },

    //切换tab按钮
    handleTabClick(tab) {
      this.tabs = tab;
      if (tab == 1) {
        this.getProcureRequest();
      } else {
        this.getShopAcceptanceList();
      }
    },
    getProcureRequest() {
      getProcureRequest(this.params).then((res) => {
        if (res.code == 0) {
          this.total = res.data.count;

          this.purchaseData = res.data.data;
        }
      });
    },
    getShopAcceptanceList() {
      getShopAcceptanceList(this.acceptanceParams).then((res) => {
        if (res.code == 0) {
          this.total = res.data.count;
          this.inspectionData = res.data.data;
        }
      });
    },
    addShopPurchase() {
      this.$router.push({
        path: "/caigouMendian/shopPurchaseEdit",
      });
    },
    inspectionEdit(id) {
      this.$router.push({
        path: "/caigouMendian/inspectionEdit",
        query: {
          id,
        },
      });
    },
    inspectionLook(id) {
      this.dialogaccept = true;
      let inspectionDetail=[]
      getDistributionInfo({
        distribution_no: id,
      }).then((res) => {
      
        if (res.code == 0) {
         inspectionDetail = res.data;
          this.sumData = this.sumGoods(res.data.linkData);
          console.log(this.sumData, inspectionDetail,'0000');
          this.inspectionDetail=inspectionDetail
        }
      });
      
    },
    editPurchase(row) {
      // console.log(row)
      this.$router.push({
        path: "/caigouMendian/shopPurchaseEdit",
        query: {
          id: row._id,
        },
      });
    },
    surePurchase(row) {
      this.$confirm("确认采购员提出的改动？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          confirmProcureRequest({
            id: row._id,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "确认成功!",
              });
              this.getProcureRequest();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    lookDl(id) {
      this.dialogDl = true;
      procureRequestDl({
        id,
      }).then((res) => {
        if (res.code == 0) {
          console.log("1111", res.data);
          this.procureRequestDetail = res.data;
          let procure_goods_list = res.data.procure_goods_list.filter(
            (item) => {
              return (
                item.procure_goods_state != 0 && item.procure_goods_state != 0
              );
            }
          );
          this.procureRequestDetail.procure_goods_list = procure_goods_list;
          this.sumData = this.sumGoods(procure_goods_list);
        }
      });
    },
    handleShopClick(type) {
      this.showType["showType" + type] = !this.showType["showType" + type];
    },

    sumGoods(arry) {
      let sumData = [];
      arry.forEach((item) => {
        let index = sumData.findIndex((ele) => {
          return item.goods.goods_type == ele.goods_type;
        });
        if (index == -1) {
          sumData.push({
            goods_type: item.goods.goods_type,
            goods: [item],
          });
        } else {
          sumData[index].goods.push(item);
        }
      });
      return sumData;
    },
    getNoCheckCount() {
      getNoCheckCount({
        shop_id: this.$store.getters.curShopInfo.shop_id,
      }).then((res) => {
        if (res.code == 0) {
          this.checkCount = res.data;
        }
      });
    },
    reset() {
      if (this.tabs == 1) {
        this.dataTime = "";
        this.params = {
          page_index: 1,
          page_size: 10,
          keyword: "",
          shop_id: this.$store.getters.curShopInfo.shop_id,
          starttime: "",
          endtime: "",
          user_id: this.$store.state.userInfo.uid,
          state: -1,
        };
        this.getProcureRequest();
      } else {
        this.acceptancedataTime = "";
        this.acceptanceParams = {
          page_index: 1,
          page_size: 10,
          keyword: "",
          acceptance_state: -1,
          shop_id: this.$store.getters.curShopInfo.shop_id,
          starttime: "",
          endtime: "",
          is_read: -1,
        };
        this.getShopAcceptanceList();
      }
    },
    fillterGoodsCustom(arry) {
      let custtomList = arry.filter((item) => {
        return item.is_check == true || item.goods_state == 4;
      });

      return custtomList;
    },
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 86;
    this.getNoCheckCount();
    if (
      this.$route.query.tabs ||
      !this.$buttonAuthority('cangku-caigouMendian-caigou')
    ) {
      this.tabs = 2;
      this.getShopAcceptanceList();
    } else {
      this.tabs = 1;
      this.getProcureRequest();
    }
  },
};
</script>

<style scoped="scoped" lang="scss">
.page {
  display: flex;
  flex-direction: column;
  .tabLine {
    display: flex;
    margin: 10px 0;

    .tabItem {
      width: 100px;
      box-sizing: border-box;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;

      &.active {
        color: $mainColor;
      }
    }
  }

  .titleView {
    background: #fff;
    height: 72px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 14px;
  }

  .mr {
    margin-right: 10px;
  }

  .comH2 {
    line-height: 64px;
    font-size: 18px;
    display: flex;
    align-items: center;
  }

  .tabView {
    margin: 20px 0;
  }

  .tableView {
    flex: 1;
    background: #fff;
  }
  .active {
    background: #f5882a;
    color: #fff;
  }

  .noactive {
    background: #fff;
    color: #000;
  }

  .titlecon {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex: 1;
    background-color: #f5f5f5;
    padding: 5px 0;
    border-radius: 5px;

    .titleleft {
      span {
        margin: 5px 20px;
        display: inline-block;
      }
    }

    .titleright {
      width: 300px;
      // margin-top: 20px;
    }
  }

  .updatetitle {
    display: flex;
    justify-content: space-around;
    height: 47px;
    line-height: 47px;
    background-color: #f5f5f5;
  }

  .remark {
    display: inline-block;
    width: 80px;
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
